import { FC, memo, useState, ChangeEvent } from 'react';

import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { ButtonsSet } from 'modules/RegisterModule/components/ButtonsSet';
import { InputForm } from '../InputForm';

export interface Step5Props {
  onSubmit: (text: string) => void;
  prevStep: () => void;
  name: string;
}

export const Step5: FC<Step5Props> = memo(({ onSubmit, prevStep, name }) => {
  const [text, setText] = useState(name);

  const onInput = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trimStart();
    if (value.length <= 50 && !(value.endsWith(' ') && text.endsWith(' '))) {
      setText(value);
    }
  };

  return (
    <Box className="flex flex-1 flex-col items-center justify-center">
      <Typography
        variant="pSemiBold"
        className="mt-8 max-w-[44rem] text-center text-[28px] md:text-[32px]"
      >
        Nice! Now, please state your first and last name
      </Typography>
      <InputForm
        placeholder="e.g. John Doe ..."
        onSubmit={() => onSubmit(text)}
        onInput={onInput}
        value={text}
        disabled={text.trim().length <= 3}
      />
      <ButtonsSet
        onBack={prevStep}
        onNext={() => onSubmit(text)}
        isNextDisabled={text.trim().length < 3}
      />
    </Box>
  );
});
